var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "ticketing-steps bg-white border-bottom" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col ticketing-step" }, [
            _c("div", { class: { "text-danger": _vm.step === 1 } }, [
              _c("i", { staticClass: "fe fe-grid" }),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(
                    this.$root.translate("ticketing.voucher.step_quantity")
                  )
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col ticketing-step" }, [
            _c("div", { class: { "text-danger": _vm.step === 2 } }, [
              _c("i", { staticClass: "fe fe-credit-card" }),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(this.$root.translate("ticketing.voucher.step_payment"))
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col ticketing-step" }, [
            _c("div", { class: { "text-danger": _vm.step === 3 } }, [
              _c("i", { staticClass: "fe fe-inbox" }),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(this.$root.translate("ticketing.voucher.step_success"))
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "header mb-3" }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-4 col-12 order-sm-last" }, [
          _vm.step === 1
            ? _c("div", { staticClass: "card card-sm" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c("div", { staticClass: "row" }, [
                    _vm.data.products.length > 0
                      ? _c("div", { staticClass: "col" }, [
                          _c("p", [
                            _vm._v(
                              "\n                  Moveek vẫn chưa chính thức bán vé Lotte Cinema. Mời bạn mua voucher vé Lotte nhé.\n                "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c("strong", { staticClass: "text-danger" }, [
                              _vm._v(
                                _vm._s(
                                  new Intl.NumberFormat("vi-VN", {
                                    style: "currency",
                                    currency: "VND",
                                  }).format(_vm.data.products[0].price)
                                ) + " cho mọi loại ghế 2D"
                              ),
                            ]),
                            _vm._v(
                              " (bao gồm ghế VIP) trong\n                  tất cả các ngày (bao gồm cuối tuần, lễ, Tết).\n                "
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._m(0),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "card d-none d-md-block" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "row align-items-center" }, [
                _c("div", { staticClass: "col" }, [
                  _c(
                    "h6",
                    {
                      staticClass: "card-title text-uppercase text-muted mb-2",
                    },
                    [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.$root.translate("ticketing.order_total")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "h2 mb-0" }, [
                    _vm._v(
                      "\n                  " +
                        _vm._s(
                          new Intl.NumberFormat("vi-VN", {
                            style: "currency",
                            currency: "VND",
                          }).format(_vm.order.total)
                        ) +
                        "\n                "
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _vm.step === 2
            ? _c("div", { staticClass: "card card-sm" }, [_vm._m(1)])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "flow-actions sticky-footer-bars" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-3" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-lg btn-outline-dark btn-block",
                    class: { disabled: _vm.step === 1 },
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        return _vm.stepHandler("prev", $event)
                      },
                    },
                  },
                  [_vm._v("\n                ←\n              ")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-9" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-lg btn-dark btn-block",
                    class: { disabled: this.cart.products.length === 0 },
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        return _vm.stepHandler("next", $event)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "d-md-none" }, [
                      _vm._v(
                        _vm._s(
                          new Intl.NumberFormat("vi-VN", {
                            style: "currency",
                            currency: "VND",
                          }).format(_vm.order.total)
                        ) + " |"
                      ),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.step === 2
                            ? _vm.$root.translate("ticketing.choose_payment")
                            : _vm.$root.translate("ticketing.continue")
                        ) +
                        "\n              "
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-8 col-12" }, [
          _vm.errors.length > 0
            ? _c("div", { staticClass: "alert alert-danger" }, [
                _vm._m(2),
                _vm._v(" "),
                _c(
                  "ul",
                  _vm._l(_vm.errors, function (error) {
                    return _c("li", [_vm._v(_vm._s(error))])
                  }),
                  0
                ),
                _vm._v(" "),
                _vm._m(3),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.errors.length === 0
            ? _c("div", [
                _vm.step === 1
                  ? _c("div", { attrs: { id: "ticketing-step-1" } }, [
                      _c("div", { staticClass: "ticketing-content" }, [
                        _c("div", { staticClass: "card" }, [
                          _c("div", { staticClass: "table-responsive" }, [
                            _c(
                              "table",
                              { staticClass: "table table-nowrap card-table" },
                              [
                                _vm._m(4),
                                _vm._v(" "),
                                _vm.data.products.length > 0
                                  ? _c(
                                      "tbody",
                                      _vm._l(
                                        _vm.data.products,
                                        function (product) {
                                          return _c("tr", [
                                            _c("td", [
                                              _vm._v(
                                                "\n                          " +
                                                  _vm._s(product.name) +
                                                  "\n                          "
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "d-block text-muted",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                            Ngày hết hạn: " +
                                                      _vm._s(
                                                        new Date(
                                                          product.expiredDate
                                                        ).toLocaleString(
                                                          "vi-VN",
                                                          {
                                                            day: "2-digit",
                                                            month: "2-digit",
                                                            year: "numeric",
                                                          }
                                                        )
                                                      ) +
                                                      "\n                          "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "d-block d-sm-none text-muted",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                            " +
                                                      _vm._s(
                                                        new Intl.NumberFormat(
                                                          "vi-VN",
                                                          {
                                                            style: "currency",
                                                            currency: "VND",
                                                          }
                                                        ).format(product.price)
                                                      ) +
                                                      "\n                          "
                                                  ),
                                                ]
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "text-right d-none d-sm-block",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                          " +
                                                    _vm._s(
                                                      new Intl.NumberFormat(
                                                        "vi-VN",
                                                        {
                                                          style: "currency",
                                                          currency: "VND",
                                                        }
                                                      ).format(product.price)
                                                    ) +
                                                    "\n                        "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "text-center" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "quantity-toggle",
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "btn btn-sm btn-rounded-circle btn-white",
                                                        class: {
                                                          disabled:
                                                            product.quantity ===
                                                            0,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.productPicker(
                                                              product,
                                                              "remove"
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("-")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      staticClass:
                                                        "form-control form-control-flush text-dark text-center d-inline",
                                                      staticStyle: {
                                                        width: "30px",
                                                      },
                                                      attrs: {
                                                        type: "text",
                                                        min: "0",
                                                        max: "10",
                                                        readonly: "",
                                                      },
                                                      domProps: {
                                                        value: product.quantity,
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "btn btn-sm btn-rounded-circle btn-white",
                                                        class: {
                                                          disabled:
                                                            product.quantity ===
                                                            10,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.productPicker(
                                                              product,
                                                              "add"
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("+")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ])
                                        }
                                      ),
                                      0
                                    )
                                  : _c("tbody", [_vm._m(5)]),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.step === 2
                  ? _c("div", { attrs: { id: "ticketing-step-2" } }, [
                      _c("div", { staticClass: "ticketing-content" }, [
                        _c("div", { staticClass: "card" }, [
                          _c("div", { staticClass: "card-header bg-light" }, [
                            _c(
                              "div",
                              { staticClass: "card-header-title text-muted" },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$root.translate(
                                        "ticketing.order_summary"
                                      )
                                    ) +
                                    "\n                  "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "table-responsive" }, [
                            _c("table", { staticClass: "table card-table" }, [
                              _vm._m(6),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                [
                                  _vm._l(_vm.cart.products, function (product) {
                                    return _c("tr", [
                                      _c("td", [_vm._v(_vm._s(product.name))]),
                                      _vm._v(" "),
                                      _c("td", { staticClass: "text-center" }, [
                                        _vm._v(_vm._s(product.quantity)),
                                      ]),
                                      _vm._v(" "),
                                      _c("td", { staticClass: "text-right" }, [
                                        _vm._v(
                                          _vm._s(
                                            new Intl.NumberFormat("vi-VN", {
                                              style: "currency",
                                              currency: "VND",
                                            }).format(
                                              product.price * product.quantity
                                            )
                                          )
                                        ),
                                      ]),
                                    ])
                                  }),
                                  _vm._v(" "),
                                  _vm._m(7),
                                  _vm._v(" "),
                                  _c("tr", [
                                    _c("td", { attrs: { colspan: "2" } }, [
                                      _vm._v("Tổng"),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "text-right" }, [
                                      _vm._v(
                                        _vm._s(
                                          new Intl.NumberFormat("vi-VN", {
                                            style: "currency",
                                            currency: "VND",
                                          }).format(_vm.order.total)
                                        )
                                      ),
                                    ]),
                                  ]),
                                ],
                                2
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card" }, [
                          _c("div", { staticClass: "card-header bg-light" }, [
                            _c(
                              "div",
                              { staticClass: "card-header-title text-muted" },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$root.translate(
                                        "ticketing.personal_information"
                                      )
                                    ) +
                                    "\n                  "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "card-body" }, [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-sm-4 col-12" }, [
                                _c("div", { staticClass: "form-group" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "required",
                                      attrs: {
                                        for: "ticketing_voucher_contact_fullname",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                          Họ và tên\n                          "
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "invalid-feedback",
                                          class: {
                                            "d-block":
                                              this.cart.checkout === true &&
                                              this.cart.contact.fullname === "",
                                          },
                                        },
                                        [_vm._m(8)]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.cart.contact.fullname,
                                        expression: "cart.contact.fullname",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    class: {
                                      "is-invalid":
                                        this.cart.checkout === true &&
                                        this.cart.contact.fullname === "",
                                    },
                                    attrs: {
                                      type: "text",
                                      id: "ticketing_voucher_contact_fullname",
                                      required: "required",
                                    },
                                    domProps: {
                                      value: _vm.cart.contact.fullname,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.cart.contact,
                                          "fullname",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-sm-4 col-12" }, [
                                _c("div", { staticClass: "form-group" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "required",
                                      attrs: {
                                        for: "ticketing_voucher_contact_phone",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                          Số điện thoại\n                          "
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "invalid-feedback",
                                          class: {
                                            "d-block":
                                              this.cart.checkout === true &&
                                              this.cart.contact.phone === "",
                                          },
                                        },
                                        [_vm._m(9)]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.cart.contact.phone,
                                        expression: "cart.contact.phone",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    class: {
                                      "is-invalid":
                                        this.cart.checkout === true &&
                                        this.cart.contact.phone === "",
                                    },
                                    attrs: {
                                      type: "tel",
                                      id: "ticketing_voucher_contact_phone",
                                      required: "required",
                                    },
                                    domProps: { value: _vm.cart.contact.phone },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.cart.contact,
                                          "phone",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-sm-4 col-12" }, [
                                _c("div", { staticClass: "form-group" }, [
                                  _c(
                                    "label",
                                    {
                                      attrs: {
                                        for: "ticketing_voucher_contact_email",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                          Email\n                        "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.cart.contact.email,
                                        expression: "cart.contact.email",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "email",
                                      id: "ticketing_voucher_contact_email",
                                    },
                                    domProps: { value: _vm.cart.contact.email },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.cart.contact,
                                          "email",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                              ]),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card" }, [
                          _c("div", { staticClass: "card-header bg-light" }, [
                            _c(
                              "div",
                              { staticClass: "card-header-title text-muted" },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$root.translate(
                                        "ticketing.payment_method"
                                      )
                                    ) +
                                    "\n                  "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "card-body" }, [
                            _c(
                              "div",
                              {
                                staticClass: "payment-gateway clearfix",
                                class: {
                                  active:
                                    this.cart.paymentGateway === "moveek" &&
                                    this.cart.paymentMethod === "BANK_TRANSFER",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.paymentMethodPicker(
                                      "moveek",
                                      "BANK_TRANSFER"
                                    )
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fe fe-check-circle pg-checked",
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "pg-info" }, [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.$root.asset(
                                        "bundles/ornweb/img/moveek-icon.png"
                                      ),
                                      alt: "",
                                    },
                                  }),
                                  _vm._v(
                                    "\n                      Chuyển khoản / Quét mã QR\n                      "
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "pm-description" },
                                    [
                                      _vm._v(
                                        "\n                        Tự động xuất mã voucher trong 30s sau khi chuyển khoản\n                      "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "payment-gateway clearfix",
                                class: {
                                  active: this.cart.paymentGateway === "momo",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.paymentMethodPicker("momo")
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fe fe-check-circle pg-checked",
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "pg-info" }, [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.$root.asset(
                                        "bundles/ornweb/img/momo-icon.png"
                                      ),
                                      alt: "",
                                    },
                                  }),
                                  _vm._v(
                                    "\n                      Ví MoMo\n                    "
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "payment-gateway clearfix",
                                class: {
                                  active:
                                    this.cart.paymentGateway === "payoo" &&
                                    this.cart.paymentMethod === "cc",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.paymentMethodPicker(
                                      "payoo",
                                      "cc"
                                    )
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fe fe-check-circle pg-checked",
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "pg-info" }, [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.$root.asset(
                                        "bundles/ornweb/img/payoo-icon.png"
                                      ),
                                      alt: "",
                                    },
                                  }),
                                  _vm._v(
                                    "\n                      Thẻ ATM / Thẻ quốc tế\n                    "
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            this.data.user.id !== null
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "payment-gateway clearfix",
                                    class: {
                                      active:
                                        this.cart.paymentGateway === "moveek" &&
                                        this.cart.paymentMethod ===
                                          "MOVEEK_CREDITS",
                                      disabled:
                                        this.cart.creditPayable === false,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.paymentMethodPicker(
                                          "moveek",
                                          "MOVEEK_CREDITS"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fe fe-check-circle pg-checked",
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "pg-info" }, [
                                      _c("img", {
                                        attrs: {
                                          src: _vm.$root.asset(
                                            "bundles/ornweb/img/moveek-icon.png"
                                          ),
                                          alt: "",
                                        },
                                      }),
                                      _vm._v(
                                        "\n                      Moveek Credits\n                      "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "pm-description" },
                                        [
                                          _vm._v(
                                            "\n                        " +
                                              _vm._s(
                                                _vm.$root.translate(
                                                  "ticketing.moveek_credits_balance"
                                                )
                                              ) +
                                              ":\n                        "
                                          ),
                                          _c(
                                            "strong",
                                            { staticClass: "text-dark" },
                                            [
                                              _vm._v(
                                                "\n                          " +
                                                  _vm._s(
                                                    new Intl.NumberFormat(
                                                      "vi-VN",
                                                      {
                                                        style: "currency",
                                                        currency: "VND",
                                                      }
                                                    ).format(
                                                      _vm.data.user.balance
                                                    )
                                                  ) +
                                                  "\n                        "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm._m(10),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "orderConfirmModal",
          tabindex: "-1",
          role: "dialog",
          "aria-hidden": "true",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "card mb-0" }, [
                _vm._m(11),
                _vm._v(" "),
                this.cart.products.length > 0
                  ? _c("div", { staticClass: "card-body" }, [
                      _c(
                        "ul",
                        {
                          staticClass: "list-group list-group-flush list mb-3",
                        },
                        [
                          _vm._m(12),
                          _vm._v(" "),
                          _vm._m(13),
                          _vm._v(" "),
                          _vm._m(14),
                          _vm._v(" "),
                          _vm._m(15),
                          _vm._v(" "),
                          _c("li", { staticClass: "list-group-item px-0" }, [
                            _c(
                              "div",
                              { staticClass: "row align-items-center" },
                              [
                                _c("div", { staticClass: "col-4 col-sm-3" }, [
                                  _vm._v("Ngày hết hạn"),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col" }, [
                                  _vm._v(
                                    _vm._s(
                                      new Date(
                                        this.cart.products[0]?.expiredDate
                                      ).toLocaleString("vi-VN", {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "numeric",
                                      })
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("li", { staticClass: "list-group-item px-0" }, [
                            _c(
                              "div",
                              { staticClass: "row align-items-center" },
                              [
                                _vm._m(16),
                                _vm._v(" "),
                                _c("div", { staticClass: "col" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(this.cart.contact?.fullname) +
                                      "\n                    "
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    _vm._s(this.cart.contact?.email) +
                                      "\n                    "
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    _vm._s(this.cart.contact?.phone) +
                                      "\n                  "
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-danger btn-block",
                          class: { disabled: _vm.order.status !== "pending" },
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              return _vm.createOrder()
                            },
                          },
                        },
                        [
                          _vm.order.status === "processing"
                            ? _c("span", {
                                staticClass: "spinner-border spinner-border-sm",
                                attrs: {
                                  role: "status",
                                  "aria-hidden": "true",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.order.status === "pending"
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$root.translate(
                                      "ticketing.choose_proceed_checkout"
                                    )
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.order.status === "awaiting_payment"
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$root.translate(
                                      "ticketing.redirect_payment_gateway_short"
                                    )
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "mb-0 text-center" }, [
      _c(
        "a",
        {
          staticClass: "text-danger",
          attrs: {
            href: "#",
            "data-toggle": "modal",
            "data-target": "#voucherPolicyModal",
          },
        },
        [_vm._v("Điều kiện sử dụng")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col" }, [
          _c("p", { staticClass: "mb-0" }, [
            _vm._v(
              "\n                  Voucher đã mua không thể đổi hoặc hoàn tiền. Voucher sẽ được gửi 01 lần qua số điện thoại\n                  và email đã nhập. Vui lòng kiểm tra lại thông tin trước khi tiếp tục.\n                "
            ),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("strong", [_vm._v("Có lỗi xảy ra:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "mb-0" }, [
      _vm._v("\n            Vui lòng thử lại hoặc "),
      _c("a", { staticClass: "text-white", attrs: { href: "/support" } }, [
        _vm._v("liên hệ trung tâm hỗ trợ"),
      ]),
      _vm._v(".\n          "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Loại")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right d-none d-sm-block" }, [
          _vm._v("Giá tiền"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Số lượng")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { attrs: { colspan: "3" } }, [
        _vm._v(
          "\n                          Không có sản phẩm nào đang khả dụng.\n                        "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Mô tả")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Số lượng")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right" }, [_vm._v("Thành tiền")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { attrs: { colspan: "2" } }, [_vm._v("Phí tiện ích")]),
      _vm._v(" "),
      _c("td", { staticClass: "text-right" }, [_vm._v("0 ₫")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "d-block" }, [
      _c(
        "span",
        { staticClass: "form-error-icon badge badge-danger text-uppercase" },
        [_vm._v("Lỗi")]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "form-error-message" }, [
        _vm._v("Giá trị không được phép để trống."),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "d-block" }, [
      _c(
        "span",
        { staticClass: "form-error-icon badge badge-danger text-uppercase" },
        [_vm._v("Lỗi")]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "form-error-message" }, [
        _vm._v("Giá trị không được phép để trống."),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "voucherPolicyModal",
          tabindex: "-1",
          role: "dialog",
          "aria-hidden": "true",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "card mb-0" }, [
                _c("div", { staticClass: "card-header" }, [
                  _c("div", { staticClass: "row align-items-center" }, [
                    _c("div", { staticClass: "col" }, [
                      _c("h4", { staticClass: "card-header-title" }, [
                        _vm._v(
                          "\n                  Điều kiện sử dụng voucher vé xem phim\n                "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-auto" }, [
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: {
                            type: "button",
                            "data-dismiss": "modal",
                            "aria-label": "Close",
                          },
                        },
                        [
                          _c("span", { attrs: { "aria-hidden": "true" } }, [
                            _vm._v("×"),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _c("p", [
                    _vm._v(
                      "1. Vé áp dụng cho tất cả suất chiếu phim 2D vào tất cả các ngày trong tuần (bao gồm Lễ, Tết) tại hệ thống\n              rạp Lotte Cinema trên toàn quốc. Ngoại trừ các suất chiếu đặc biệt theo quy định của nhà sản xuất hoặc nhà\n              phát hành phim công bố tại từng thời điểm."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "2. Không áp dụng cho phim 3D và các phòng chiếu đặc biệt khác như Superplex, Cinecomfort, Charlotte..."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "3. Khách hàng sẽ nhận được 01 mã đổi vé xem phim điện tử trên toàn hệ thống Lotte Cinema."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "4. Mỗi Mã phiếu đổi vé xem phim điện tử có thể quy đổi thành 01 vé xem phim 2D - cho loại ghế Thường hoặc VIP tại quầy vé."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("5. Một khách hàng được mua nhiều voucher")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "6. E-Voucher/E-Coupon không có giá trị quy đổi thành tiền mặt, không trả lại tiền thừa, không được hoàn hủy."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "7. Không áp dụng đồng thời với chương trình khuyến mại khác."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("8. Vé được cung cấp dưới dạng mã code.")]),
                ]),
              ]),
            ]),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("div", { staticClass: "row align-items-center" }, [
        _c("div", { staticClass: "col" }, [
          _c("h4", { staticClass: "card-header-title" }, [
            _vm._v("\n                  Xác nhận đơn hàng\n                "),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-auto" }, [
          _c(
            "button",
            {
              staticClass: "close",
              attrs: {
                type: "button",
                "data-dismiss": "modal",
                "aria-label": "Close",
              },
            },
            [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "list-group-item px-0" }, [
      _c("div", { staticClass: "row align-items-center" }, [
        _c("div", { staticClass: "col-4 col-sm-3" }, [_vm._v("Rạp")]),
        _vm._v(" "),
        _c("div", { staticClass: "col" }, [_vm._v("Lotte Cinema")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "list-group-item px-0" }, [
      _c("div", { staticClass: "row align-items-center" }, [
        _c("div", { staticClass: "col-4 col-sm-3" }, [_vm._v("Phim")]),
        _vm._v(" "),
        _c("div", { staticClass: "col" }, [_vm._v("Các phim đang chiếu")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "list-group-item px-0" }, [
      _c("div", { staticClass: "row align-items-center" }, [
        _c("div", { staticClass: "col-4 col-sm-3" }, [_vm._v("Suất")]),
        _vm._v(" "),
        _c("div", { staticClass: "col" }, [
          _vm._v("Các suất 2D (bao gồm cuối tuần, lễ, Tết)"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "list-group-item px-0" }, [
      _c("div", { staticClass: "row align-items-center" }, [
        _c("div", { staticClass: "col-4 col-sm-3" }, [_vm._v("Ghế")]),
        _vm._v(" "),
        _c("div", { staticClass: "col" }, [
          _vm._v("Ghế 2D (bao gồm cả ghế VIP)"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-4 col-sm-3" }, [
      _vm._v("Thông tin"),
      _c("br"),
      _vm._v("cá nhân"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }